import { useAuthentication } from '@ecosystem/newron-client-lib';
import { useEffect, useState } from 'react';

import { UpsellPriorities, UpsellType } from '../common';
import {
  RetailKADMessageRequestBody,
  RetailKADMessageResponse,
  getRetailKADMessageService,
} from '../services/Market.service';

interface UseRetailKADUpsellMessageResult {
  retailKADMessage: RetailKADMessageResponse | undefined;
}

export const useRetailKADUpsellMessage = (cells: string[]): UseRetailKADUpsellMessageResult => {
  const [isMounted, setIsMounted] = useState<boolean>(true);
  const [retailKADMessage, setRetailKADMessage] = useState<RetailKADMessageResponse | undefined>(undefined);

  const { getAccessToken } = useAuthentication();

  useEffect(() => {
    setIsMounted(true);
  }, [cells]);

  useEffect(() => {
    (async () => {
      const token = await getAccessToken();

      const retailKADMessageRequestBody: RetailKADMessageRequestBody = {
        marketFilters: cells?.map(cell => ({
          countryCode: cell.split('-')[0],
          itemGroupCode: cell.split('-')[1],
        })),
      };
      if (isMounted) {
        if (UpsellPriorities.get(UpsellType.RETAIL_KAD_UPSELL)) {
          const retailKADMessageResponse = await getRetailKADMessageService(token, retailKADMessageRequestBody);
          const sortedRetailKADMessageResponse = retailKADMessageResponse.sort(
            (a, b) => Number(a.priority) - Number(b.priority)
          );
          setRetailKADMessage(sortedRetailKADMessageResponse[0]);
        }
      }
    })();
    return () => {
      setIsMounted(false);
      setRetailKADMessage(undefined);
    };
  }, [cells, getAccessToken, isMounted]);

  return {
    retailKADMessage,
  };
};
